import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WeeklyResultByStoreReportService } from '../../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { WeeklyResultByBranchService } from '../weekly-result-by-branch.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';

@Component({
  selector: 'app-weekly-result-by-branch-view',
  standalone: false,
  templateUrl: './weekly-result-by-branch-view.component.html',
  styleUrl: './weekly-result-by-branch-view.component.scss'
})
export class WeeklyResultByBranchViewComponent {

  reportData: any[] = [];
  requestData: any = null;
  totals: any = {};
  IsDownloading: boolean = false;
  totalDetails: any = {};
  isLoading: boolean = false;

  displayedColumns: string[] = [
    'shop_name',
    'this_year_this_week_sales',
    'last_year_this_week_sales',
    'sales_var',
    'sales_var_percent',
    'this_week_cust_orders',
    'last_year_cust_orders',
    'orders_var',
    'orders_var_percent',
    'avg_sale_ty',
    'avg_sale_ly',
    'labour_percent_ty',
    'labour_percent_ly',
    'labour_percent_var'
  ];

  groupHeaderColumns: string[] = ['shopGroup', 'salesGroup', 'ordersGroup', 'labourGroup'];

  constructor(
    private weeklyResultByBranchService: WeeklyResultByBranchService,
    private router: Router,
    private snackBarService: SnackBarService
  ) {
    const weeklyBranchReportData = sessionStorage.getItem('weeklyBranchReportData');
    if (weeklyBranchReportData) {
      this.requestData = JSON.parse(weeklyBranchReportData);
      console.log('Request Data:', this.requestData);
    } else {
      console.log('Data not found in sessionStorage');
    }
  }

  ngOnInit(): void {
    this.WeeklyBranchReport(); // Call API function separately
  }

  WeeklyBranchReport(): void {
    if (this.requestData) {
      this.isLoading = true;
      this.weeklyResultByBranchService.getWeekBranchViewList(this.requestData).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response && response.data && response.data.sales_list) {
            this.reportData = response.data.sales_list;

            // ✅ SIMPLE - Map API response directly to totalDetails using the new response structure
            this.totalDetails = {
              total_ytd_sales: response.data.sales_summary.total_ytd_sales,
              total_ly_sales: response.data.sales_summary.total_ly_sales,
              sales_variance: response.data.sales_summary.sales_variance,
              sales_growth: response.data.sales_summary.sales_growth,
              total_cust_order_ty: response.data.sales_summary.total_cust_order_ty,
              total_cust_order_ly: response.data.sales_summary.total_cust_order_ly,
              cust_order_variance: response.data.sales_summary.cust_order_variance,
              cust_order_growth: response.data.sales_summary.cust_order_growth,
              avg_sales_per_order_ty: response.data.sales_summary.avg_sales_per_order_ty,
              avg_sales_per_order_ly: response.data.sales_summary.avg_sales_per_order_ly,
              // ✅ Use the new labour percentage fields from API
              total_labour_cost_ty: response.data.sales_summary.labour_percentage_ty,
              total_labour_cost_ly: response.data.sales_summary.labour_percentage_ly,
              labour_cost_growth: response.data.sales_summary.labour_percentage_variance
            };

            console.log('API Response:', this.reportData);
            console.log('Total Details:', this.totalDetails);
          } else {
            console.warn('Unexpected API response structure:', response);
            this.reportData = [];
            this.totalDetails = {};
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error fetching data:', error);
        }
      });
    }
  }

  exportClicked(): void {
    const exportPayload = JSON.parse(JSON.stringify(this.requestData));
    exportPayload.isExport = 1;

    if (exportPayload) {
      this.IsDownloading = true;

      this.weeklyResultByBranchService.getWeekBranchExportList(exportPayload).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              }
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'weekly-report-by-branch.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }

  getWeekEndingDate(financialYear: number, weekNo: number): string {
    // Financial Year starts on April 1st
    let financialYearStart = new Date(financialYear, 3, 1); // April 1st (month index 3 = April)

    // Get the day of the week for April 1st (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    let dayOfWeek = financialYearStart.getDay();

    // Calculate the first Sunday of the financial year
    let firstSunday = new Date(financialYearStart);
    if (dayOfWeek !== 0) {
      firstSunday.setDate(firstSunday.getDate() + (7 - dayOfWeek)); // Move to the first Sunday
    }

    // Calculate the week-ending Sunday for the given week number
    let endOfWeek = new Date(firstSunday);
    endOfWeek.setDate(endOfWeek.getDate() + (weekNo - 1) * 7);

    // Format the date in local timezone as YYYY-MM-DD
    const year = endOfWeek.getFullYear();
    const month = String(endOfWeek.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(endOfWeek.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  navBack(): void {

    this.router.navigate(['/report/weekly-result-by-branch']);


  }
}